<main class="c-main wow-consulta">
  <div class="container-fluid">
    <div class="row">
      <div class="alert alert-danger" role="alert" *ngFor="let erro of mensagemErros">
        {{ erro }}
      </div>
    </div>
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-consulta__header">
          <div class="wow-consulta__header-icon"><mat-icon>point_of_sale</mat-icon></div>
          <mat-card-title>Caixas</mat-card-title>
        </div>

        <app-wow-consulta-filtros
          [tipoFiltros]="tipoFiltros"
          [(tipoFiltro)]="tipoFiltro"
          [(parametro)]="parametro"
          [parametroMask]="tipoFiltro === 'ID' ? 'separator.0' : ''"
          [showSituacao]="true"
          [(situacao)]="situacao"
          (consultar)="consultar()"
          (novo)="novo()">
        </app-wow-consulta-filtros>

        <div class="wow-consulta__empty" *ngIf="!consultaRealizada">
          Clique em <strong>Consultar</strong> para listar os caixas.
        </div>

        <ng-container *ngIf="consultaRealizada">
          <table mat-table [dataSource]="boxs" class="full-width">
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let box">{{ box.id }}</td>
            </ng-container>
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Nome</th>
              <td mat-cell *matCellDef="let box">{{ box.name }}</td>
            </ng-container>
            <ng-container matColumnDef="pixBalance">
              <th mat-header-cell *matHeaderCellDef>Saldo Pix</th>
              <td mat-cell *matCellDef="let box">{{ box.pixBalance | currency:'BRL' }}</td>
            </ng-container>
            <ng-container matColumnDef="caixaBalance">
              <th mat-header-cell *matHeaderCellDef>Saldo Caixa</th>
              <td mat-cell *matCellDef="let box">{{ box.caixaBalance | currency:'BRL' }}</td>
            </ng-container>
            <ng-container matColumnDef="cartaoBalance">
              <th mat-header-cell *matHeaderCellDef>Saldo Cartão</th>
              <td mat-cell *matCellDef="let box">{{ box.cartaoBalance | currency:'BRL' }}</td>
            </ng-container>
            <ng-container matColumnDef="active">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let box">
                <span *ngIf="box.active == true || box.active === 'true'; else inativo" class="text-primary">Ativo</span>
                <ng-template #inativo>
                  <span class="text-danger">Inativo</span>
                </ng-template>
              </td>
            </ng-container>
            <ng-container matColumnDef="excluir">
              <th mat-header-cell *matHeaderCellDef>Excluir</th>
              <td mat-cell *matCellDef="let box" (click)="$event.stopPropagation()">
                <button (click)="openDialog(box.id)" mat-icon-button color="warn">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="editar">
              <th mat-header-cell *matHeaderCellDef>Editar</th>
              <td mat-cell *matCellDef="let box" (click)="$event.stopPropagation()">
                <button (click)="editar(box.id)" mat-icon-button color="accent">
                  <mat-icon>edit</mat-icon>
                </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="ordemColunasTabela"></tr>
            <tr mat-row *matRowDef="let row; columns: ordemColunasTabela;" class="wow-consulta__row"
              (click)="editar(row.id)"></tr>
          </table>

          <mat-paginator [length]="totalElementos" [pageSize]="tamanho"
            [pageSizeOptions]="pageSizeOptions" (page)="paginar($event)">
          </mat-paginator>
        </ng-container>
      </mat-card>
    </div>
  </div>
</main>
